import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "buttons-wrapper" }

import IconButton from "../IconButton.vue";
interface Props {
  setSubscribeVisible: Function;
  setVisible: Function;
  condensed?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DisablePersonalNote',
  props: {
    setSubscribeVisible: { type: Function },
    setVisible: { type: Function },
    condensed: { type: Boolean }
  },
  setup(__props: any) {

const CloseGreyIcon = require("../../assets/images/Close-grey.svg") as string;

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    autofocus: "",
    "v:focustrap": "",
    title: "Subscribe popup",
    class: _normalizeClass(["disable-personal-note-dialog", { condensed: props.condensed }])
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "disable-personal-note-dialog-body-text" }, " The personal notes feature is only available to subscription accounts. Subscribe to unlock full access! ", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        "aria-label": "Subscribe",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (props.setSubscribeVisible(true))),
        class: "diable-personal-note-dialog-body-button"
      }, " Subscribe "),
      _createVNode(IconButton, {
        icon: _unref(CloseGreyIcon),
        class: "disable-personal-note-dialog-close-icon",
        alt: "Close",
        onclick: 
          () => {
            props.setVisible(false);
          }
        ,
        enterPress: () => {
            props.setVisible(false);
          }
        ,
        ariaLabel: "Close subscribe dialog",
        xxsmall: ""
      }, null, 8, ["icon", "onclick", "enterPress"])
    ])
  ], 2))
}
}

})